import { render } from "./NewMailAccount.vue?vue&type=template&id=61485eea&scoped=true"
import script from "./NewMailAccount.vue?vue&type=script&lang=js"
export * from "./NewMailAccount.vue?vue&type=script&lang=js"

import "./NewMailAccount.vue?vue&type=style&index=0&id=61485eea&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61485eea"]])

export default __exports__